import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { appAxios } from '@/network/base/appAxios';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

const CancelSubscriptionModal = ({ isOpen, onClose, onCancelled, planName, renewDate }) => {
  const [isCancelling, setIsCancelling] = useState(false);
  const [currentStep, setcurrentStep] = useState("manage")
  const navigate = useNavigate();
  if (!isOpen) return null;

  const handleCancelSubscription = async () => {
    setIsCancelling(true);
    try {
      await appAxios.post('/Subscription/v1.0/cancel-subscription');
      toast.success('Subscription cancelled successfully.');
      onCancelled?.();
      onClose();
    } catch (error) {
      console.error('Failed to cancel subscription:', error);
      toast.error('Failed to cancel subscription. Please try again.');
    } finally {
      setIsCancelling(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50">
      <div className="bg-[#1a1a1a] rounded-2xl p-8 max-w-md w-full mx-4 relative flex flex-col justify-center items-center">
        <button onClick={() => { onClose(); setcurrentStep("manage") }} className="absolute top-4 right-4 text-gray-400 hover:text-white">
          <X className="w-5 h-5" />
        </button>

        {/* Manage Subscription Step */}
        {currentStep === "manage" && (
          <>
            <h2 className="text-2xl font-semibold text-white text-center mb-4">Manage subscription</h2>
            <p className="text-gray-300 text-center mb-10 max-w-xs mx-auto leading-relaxed">
              Upgrade or cancel anytime
            </p>
            <button
              onClick={() => setcurrentStep("cancel")}
              disabled={isCancelling}
              className="w-full bg-[#212121] hover:bg-[#212121]/90 border border-[#515151] text-white py-3 rounded-lg mb-3 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              Cancel Subscription
            </button>
            <button
              onClick={() => navigate('/citypermit/subscription')}
              disabled={isCancelling}
              className="w-full bg-[#7B7B7B] hover:bg-gray-500 text-white py-3 rounded-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              Upgrade Plan
            </button>
          </>
        )}

        {/* Cancel Subscription Step */}
        {currentStep === "cancel" && (
          <>
            <div className="w-12 h-12 rounded-full border-2 border-[#7a2020] bg-[#2a1010] flex items-center justify-center mb-5">
              <span className="text-white text-xl leading-none p-1 border border-[#7a2020] rounded-full w-8 h-8 flex items-center justify-center">!</span>
            </div>
            <h2 className="text-2xl font-semibold text-white text-center mb-4">Cancel subscription?</h2>
            <p className="text-gray-300 text-center mb-7 max-w-xs mx-auto leading-relaxed">
              You&apos;ll keep access to <strong className="text-white">{planName}</strong> until{' '}
              <strong className="text-white">{renewDate}</strong>. After that, your account will revert to the free plan
              and unused credits will be lost.
            </p>
            <button
              onClick={handleCancelSubscription}
              disabled={isCancelling}
              className="w-full bg-[#3d1515] hover:bg-[#4f1a1a] border border-[#7a2020] text-white py-3 rounded-lg mb-3 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {isCancelling ? 'Cancelling...' : 'Yes, Cancel Subscription'}
            </button>
            <button
              onClick={() => { onClose(); setcurrentStep("manage") }}
              disabled={isCancelling}
              className="w-full bg-[#7B7B7B] hover:bg-gray-500 text-white py-3 rounded-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              Keep Subscription
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default CancelSubscriptionModal;
